import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dataUser: {},
    canPlay: false,
    session: null,
    bell: {
      status: false
    },
    alerts: false,
    showNotification: false,
    operator_name: null,
    replies: [],
  },

  mutations: {
    setDataUser: (state, data) => {
      state.dataUser = data;
      state.session = data.session
      state.operator_name = localStorage.getItem('operator_name') || data.name;
    },

    logout(state) {
      state.dataUser = {};
      localStorage.removeItem('operator_name');
    },

    setBell(state, data) {
      state.bell = { status: !!data };
      // document.title = (data ? `(${data}) ` : '') + "Lebot";
    }
  },
  actions: {
  },
  modules: {
  }
})
